import { ProductAttributesService } from '../../services/productAttributes';
import { BOAT_TYPE_TO_PRODUCT_ID, ALL_PRODUCT_IDS } from './types';

/**
 * Pre-configured singleton of ProductAttributesService for Premier Marine.
 *
 * Default product: Sunsation (2646).
 * Switch to another boat with `premierMarineService.setProductId(id)`.
 *
 * @example
 * ```ts
 * import { premierMarineService, preloadAllProducts } from '../configurator/premierMarine';
 *
 * // Preload all boats on app start (parallel, cached)
 * await preloadAllProducts();
 *
 * // Fetch for a specific boat (from cache after preload)
 * const solaris = await premierMarineService.getAttributes(2647);
 * ```
 */
export const premierMarineService = new ProductAttributesService({
  apiBaseUrl: 'https://renderadmin.vivid3d.tech',
  productId: BOAT_TYPE_TO_PRODUCT_ID.sunsation, // 2646
});

// ── Preload helper ──────────────────────────────────────────────

let _preloadPromise: Promise<void> | null = null;

/**
 * Preload all Premier Marine products in parallel.
 * Safe to call multiple times — subsequent calls return the cached promise.
 * After preload `premierMarineService.getAttributes(productId)` resolves
 * instantly from the internal cache.
 */
export function preloadAllProducts(): Promise<void> {
  if (!_preloadPromise) {
    _preloadPromise = premierMarineService
      .preloadProducts(ALL_PRODUCT_IDS)
      .catch((err) => {
        console.error('[preloadAllProducts] failed:', err);
        // Reset so a subsequent call can retry
        _preloadPromise = null;
      });
  }
  return _preloadPromise;
}
